import Question from './Question';

const QuestionContainer = ({ currentQuestion, handleAnswer }) => {
  return (
    <Question currentQuestion={currentQuestion} handleAnswer={handleAnswer} />
  );
}

export default QuestionContainer;
